<!--
 * @Description: 
 * @Author: xuxiaofei
 * @Date: 2021-11-19 10:58:10
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @LastEditTime: 2022-09-01 15:09:34
-->
<template>
  <div class="extend-field">
    <SyForm
		  :model="extendFieldForm"
			ref="fieldForm"
			style="font-size: 0"
			:pageType='pageType'
      :follow="follow"
			:span="span"
			:styleType="formstyleType"
		>
			<template v-for="(item, index) in fieldList">
				<SyFormItem
					v-if="index < 6"
					:label="item.fieldName"
					:key="item.sysFieldCode"
					:isText="true"
					:span="item.bannerDisplay === 1 ? '0' : undefined"
				>
					<div class="field-value">
						<ReadText v-if="[1, 2, 3, 4, 5].includes(item.fieldType)" :value="extendFieldForm[item.sysFieldCode] || '-'" computeHeight></ReadText>
						<!-- 图片 -->
						<div v-if="item.fieldType === 6">
							<div
								class="file-item font-color-hover-primary"
								v-for="(item, index) in accessoryField(extendFieldForm[item.sysFieldCode], item.fieldType)"
								:key="index"
								@click="downloadImg(item)"
							>
								<span class="accessory-file-detail_item-status"></span>
								<i class="el-icon-download"></i>
								<span>{{item.name}}</span>
							</div>
						</div>
						<!-- 附件 -->
						<SyAccessory
							v-if="item.fieldType === 7"
							size="mini"
							:ediTable="false"
							:onlyImage="false"
							:firstImgOnly="false"
							:isChunk="true"
							maxFileSize="5MB"
							:fileList="accessoryField(extendFieldForm[item.sysFieldCode])"
							></SyAccessory>
						</div>
				</SyFormItem>
			</template>
		</SyForm>
		<span v-if="Array.isArray(fieldList) && fieldList.length === 0">-</span>
  </div>
</template>
        
<script>
/* eslint-disable */
import { ReadText, Buttons } from './../../../../index.js'
import SyAccessory from './../../../basis/sy-accessory/sy-accessory.vue'
import { componentMessage } from './../../utils'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)

export default {
  name: 'ExtendFieldDetaile',
	components: {
		Buttons,
		SyAccessory,
		ReadText
	},
	props: {
		// 需求提报的id
    demandData: {
      type: Object,
			required: true,
			default: () => ({
				demandId: null,
				fieldList: []
			})
    },
		// 一行几列
    span: {
      type: [Number, String]
    },
    // 页面类型,弹窗形式值为'popup'
    pageType: {
      type: String
    },
    // 表单是否跟随
    follow: {
      type: Boolean,
      default: true
    },
		// 组件是否应用于表格 styleType='mini'
		formstyleType: {
			type: String,
			default: 'mini'
		}
	},
  data () {		
    return {
			pageText,
      extendFieldForm: {},
			project: window.fe.project,
			fieldList: [],
			demandId: null
    }
  },
  watch: {
		demandData: {
      handler: function (newVal) {
				console.log(newVal)
				let list = Array.isArray(newVal?.fields) ? JSON.parse(JSON.stringify(newVal.fields)) : []
				// 只展示摘要字段
				this.fieldList = list.filter(item => !(this.project === 'supplier' && item?.supplierDisplay === 0) && item.formDisplay === 1)
				this.transformData()
        this.demandId = newVal?.sysBizDataCode
      },
      immediate: true
    }
	},
	computed: {
		// 给附件列表补充filePath和url字段
		accessoryField () {
			return function (fieldArr, fieldType) {
				Array.isArray(fieldArr) && fieldArr.forEach(i => {
          !i.filePath && i.url && this.$set(i, 'filePath', i.url)
					!i.url && i.filePath && this.$set(i, 'url', i.filePath)
					!i.name && (i.name = '-')
					if (fieldType === 6) {
						i.filePath = window.fe.imgHost + i.url
					}
				})
				return fieldArr
			}
		}
	},
	created () {
		let verifyResult = componentMessage(['purchaser', 'supplier', 'mall'], '扩展字段详情组件 detail-for-table')
		if (verifyResult) return
	},
  methods: {
    transformData () {
			this.extendFieldForm = {}
      this.fieldList.forEach((item, index) => {
				item.copySysFieldCode = item.sysFieldCode
				item.sysFieldCode = 'custom' + item.sysFieldCode
				// 设置form
				let value = null
				switch (item.fieldType) {
					// 文本类型 textVal  String类型 
					case 1:
					case 2:
					case 3:
					case 4:
					case 5:
						value = item?.fieldValue?.textVal || null
						break
					case 6:
					case 7:
						if (item?.fieldValue?.fileVals) {
              value = item?.fieldValue?.fileVals || []
						} else {
              value = []
						}
						break
				}
				this.$set(this.extendFieldForm, item.sysFieldCode, value)
			})
			console.log(this.extendFieldForm)
		},
		// 下载图片
		downloadImg (data) {
			window.location.href = data.filePath
		}
  }
}
</script>

<style lang="scss" scoped>
.extend-field {
	font-size: 14px;
	.field-value {
		word-wrap: break-word;
    word-break: normal;
		display: inline-block;
	}
	.file-item {
		cursor: pointer;
		font-size: 14px;
		// height: 24px;
		line-height: 24px;
		overflow: hidden;
		color: #303030;
		width: 100%;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		max-height: 48px;
		.accessory-file-detail_item-status {
			display: inline-block;
			vertical-align: middle;
			width: 20px;
			height: 20px;
			background: url($img-url + '163663639174472357.png') no-repeat;
			background-size: 50px;
			background-position: -25px -40px;
		}
		word-break: break-all;
		.el-icon-download {
			display: none;
		}
		&:hover {
			background: #F9F9F9;
			border-radius: 14px;
			.el-icon-download {
				display: inline-block;
			}
			.accessory-file-detail_item-status {
				display: none;
			}
		}
	}
}
</style>
